import { MobileShell } from '@/components/dashboard/DashboardShell';
import { BusRoutesContent } from '@/components/dashboard/BusRoutesContent';

export default function BusSchedulesMobile() {
  return <BusRoutesContent Shell={MobileShell} mode="mobile" />;
}
